import { ImportAppId, ImportTabConfig } from "./import-types";
import { getFilteredNotesApps } from "./import-steps.config";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import styled from "@emotion/styled";

interface Props {
  selectedAppId: string | null;
  onAppSelect: (appId: ImportAppId) => void;
  tabConfig?: ImportTabConfig;
}

export const Tabs: React.FC<Props> = ({
  selectedAppId,
  onAppSelect,
  tabConfig = { tabs: getFilteredNotesApps() },
}) => (
  <StyledTabsContainer>
    {tabConfig.tabs
      .filter(app => !app.omitFromTabs)
      .map(app => {
        const isActive = selectedAppId === app.id;
        return (
          <StyledTab key={app.id} isActive={isActive} onClick={() => onAppSelect(app.id)}>
            <MDSText
              variant={MDSTextVariant.ParagraphSm}
              weight={isActive ? MDSTextWeight.Smedium : MDSTextWeight.Regular}
              color={isActive ? MDSTextColor.Primary : MDSTextColor.Tertiary}
            >
              {app.title}
            </MDSText>
          </StyledTab>
        );
      })}
  </StyledTabsContainer>
);

export const StepContentWithTabs: React.FC<Props & { children: React.ReactNode }> = ({
  selectedAppId,
  onAppSelect,
  tabConfig = { tabs: getFilteredNotesApps() },
  children,
}) => (
  <StyledStepContentWithTabsContainer>
    <Tabs selectedAppId={selectedAppId} onAppSelect={onAppSelect} tabConfig={tabConfig} />
    {children}
  </StyledStepContentWithTabsContainer>
);

const StyledTabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: -4px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.border.default};
`;

const StyledTab = styled.button<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["4"]};
  padding-inline: ${({ theme }) => theme.spacing[3]};
  padding-block: ${({ theme }) => theme.spacing[1]};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  border-bottom: ${({ theme, isActive }) =>
    isActive ? `2px solid ${theme.colors.border.emphasis}` : "none"};
  margin-bottom: -2px;
`;

export const StyledStepContentWithTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${({ theme }) => theme.spacing[2]};
  padding-bottom: ${({ theme }) => theme.spacing[4]};
  padding-inline: ${({ theme }) => theme.spacing[3]};
  gap: ${({ theme }) => theme.spacing[4]};
`;
